<template>
  <div id="app" :class="[$store.state.device.isPC ? 'app' : 'mobileApp']">
    <div v-if="initialLoading"></div>
    <template v-else>
      <keep-alive>
        <router-view v-if="!$store.state.device.isPC"></router-view>
        <router-view v-else-if="$store.state.device.isPC && $route.meta.keepAlive"></router-view>
      </keep-alive>
      <router-view v-if="$store.state.device.isPC && !$route.meta.keepAlive"></router-view>

      <CookieDiv></CookieDiv>
    </template>
  </div>
</template>
<script>
import { getToken } from '@/utils/auth'
import CookieDiv from '@/components/Cookie'
import {
  getCountryByIp
} from '@/api/user'
export default {
  data () {
    return {
      initialLoading: true // 添加加载状态
    }
  },
  components: {
    CookieDiv,
  },
  methods: { // 方法
    addEventListener(){
      window.addEventListener('resize', this.handleResizeDevice)
    },
    // 直接根据宽度 850
    handleResize(e){
      // 判断是否是 pc 或者 移动端
      // 默认设置当屏幕宽度 > 1000 时，为PC端
      if (document.documentElement.clientWidth > 850) {    
        this.$store.commit('setIsPc',true)
      } else {
        // 默认设置当屏幕宽度 <= 1000 时，为移动端
        this.$store.commit('setIsPc',false)
      }
    },
    // 先根据设备
    handleResizeDevice(){
      const width = document.documentElement.clientWidth
      this.$store.commit('setDeviceWidth',width)
      // 先判断 UA 是否为移动端设备（手机&平板）
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          this.$store.commit('setIsPc',false)
      } else {
          // 如果为桌面设备，再根据页面宽度判断是否需要切换为移动端展示
          if (width < 850) {
            this.$store.commit('setIsPc',false)
          } else {
            this.$store.commit('setIsPc',true)
            document.body.style.overflow = '';
          }
      }
      // console.log('isPC:',this.$store.state.device.isPC)
    },
    removeEventListener(){
      window.removeEventListener('resize', this.handleResizeDevice)
    },

    // 标题设置
    setTitle(title) {
      // document.title = process.env.VUE_APP_NAME + '-' + title
      document.title = this.$i18n.t('page_aboutTeam.misn')
    },

    // 获取浏览器的语言
    getBrowserLanguage(){
      const language = navigator.language || navigator.userLanguage;
      // 判断语言
      if (language.includes('zh')) {
        return 'zh'; // 中文
      } else {
        return 'en'; // 默认英语
      }
    },
    async setBrowserLanguage(){
      const language = this.getBrowserLanguage()
      console.log(language)
      const userLang = localStorage.getItem("change-language")
      if(userLang){
        // 有用户自己的之前选择的语言
        this.$i18n.locale = userLang;
      } else {
        // 没有用户自己的之前选择的语言
        if(language.includes('zh')){
          this.$i18n.locale = 'zh-CN';
          localStorage.setItem("change-language", 'zh-CN');
        } else {
          this.$i18n.locale = 'en';
          localStorage.setItem("change-language", 'en');
        }
      }
      // 确保 Vue 的响应式更新完成
      await this.$nextTick();
    },

    // 根据ip获取国家来切换语言
    async getIpCountry(){
      try {
        const res = await getCountryByIp()
        if (res.code == 0) {
          sessionStorage.setItem('country', res.data?.country || '')
          await this.goCountryLang()
        }
      } catch (error) {
        console.error('Failed to get country by IP:', error)
        // 如果IP获取失败，回退到浏览器语言设置
        await this.setBrowserLanguage()
      }
    },
    async goCountryLang(){
      const country = sessionStorage.getItem('country') || ''
      const userLang = localStorage.getItem("change-language")
      if(country){
        if(userLang){
          this.$i18n.locale = userLang
        } else {
          if(country == 'China'){
            this.$i18n.locale = 'zh-CN';
            localStorage.setItem("change-language", 'zh-CN');
          } else {
            this.$i18n.locale = 'en';
            localStorage.setItem("change-language", 'en');
          }
        }
      } else {
        await this.setBrowserLanguage()
      }
      // 确保 Vue 的响应式更新完成
      await this.$nextTick();
    },

    async initializeApp() {
      // 首次检测设备
      this.handleResizeDevice()
      
      // 初始化语言设置
      const country = sessionStorage.getItem('country') || ''
      if (!country) {
        await this.getIpCountry()
      } else {
        this.goCountryLang()
      }
      
      // 其他初始化操作
      this.addEventListener()
      if (getToken()) {
        this.$store.dispatch('readLocalUserInfo')
      }
    },
  },
  async mounted () { // 页面进入时加载内容
    // 测试函数使用的 忽略此代码 
    // console.log('模拟语言设置延迟 300ms...');
    // await new Promise(resolve => setTimeout(resolve, 300));
    this.initialLoading = true
    try {
      await this.initializeApp()
    } catch (error) {
      console.error('App initialization failed:', error)
    } finally {
      this.initialLoading = false
    }
  },
  watch: { // 监测变化
    //监听路由
    $route(to,from){
      window.scrollTo(0, 0);
      this.setTitle(to.meta.title)
      this.$store.commit('setActivePath',to.path)
      if(getToken()){
        var userType = localStorage.getItem('userType') || 'doctor'
        if(userType == 'doctor'){
          this.$store.dispatch('getUserInfo')
          this.$store.dispatch('getMessagePoint')
        } else {
          this.$store.dispatch('mfGetUserInfo')
        }
      }
    }
  },
  beforeDestroy () { // 页面销毁时
    this.removeEventListener()
  },
}
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
